import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as postActions from "src/store/action/post";
import * as configActions from "src/store/action/config";
import PostItem from "src/components/posts/item";
import ApiService from "src/services/ApiService";
import LoadingTable from "./components/loading-table";
import HeaderMobileComponent from "src/components/layout/header-mobile";

const RealtimePosts = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [posts, setPosts] = useState([]);
  const [penNames, setPenNames] = useState([]);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);

    const fetchData = async () => {
      const realtimePostsData = (
        (await ApiService.get("/top-view-posts")) || {}
      ).posts;
      const postsData = [];

      (realtimePostsData || []).forEach((row) => {
        if (row.post) {
          row.post.view = row.view;
          postsData.push(row.post);
        }
      });

      setPosts(postsData);
    };

    props.getPennames();    

    fetchData();

  }, []);

  useEffect(() => {
    if (props.config && props.config.listPenname) {
      const fPennames = props.config.listPenname.map(item => {
        return {
          label: item.label,
          value: item
        };
      });
      setPenNames(fPennames);
    }
  }, [props.config]);

  return (
    <div
      className={
        "content-wrapper post-list-container" + (isMobile ? " mobile" : "")
      }
    >
      <section className="content-header">
        <div className="container-fluid">
          <HeaderMobileComponent />
        </div>
      </section>

      <section className={"content" + (isMobile ? " list-mobile" : "")}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card card-default color-palette-box">
                <div className="card-body table-responsive p-0">
                  <table className="table table-hover">
                    {!isMobile ? (
                      <thead>
                        <tr>
                          <th></th>
                          <th>Tiêu đề bài viết</th>
                          <th>Trạng thái</th>
                          <th>Chuyên Mục</th>
                          <th>View</th>
                        </tr>
                      </thead>
                    ) : (
                      <thead></thead>
                    )}
                    <tbody>
                      {penNames.length > 0 && posts.length > 0 ? (
                        posts.map((post, idx) => {
                          return (
                            <PostItem
                              postItem={post}
                              key={`post-${idx}`}
                              contentcreatortype={penNames}
                              hideContentPenname={true}
                              hideUser={true}
                              showView={true}
                            />
                          );
                        })
                      ) : (
                        <LoadingTable />
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default connect(
  (store) => {
    return {
      profile: store.loginInfo.userInfo,
      router: store.router,
      posts: store.post.listPost,
      totalPosts: store.post.totalPosts,
      config: store.config,
    };
  },
  (dispatch) => {
    return {
      getListPost: (value) => {
        dispatch(postActions.getListPost(value));
      },
      countListPost: (value) => {
        dispatch(postActions.countListPost(value));
      },
      updateListPost: (value) => {
        dispatch(postActions.updateListPost(value));
      },
      updatePost: (value) => {
        dispatch(postActions.updatePost(value));
      },
      getPennames: (value) => {
        dispatch(configActions.getPennames(value));
      },
    };
  }
)(RealtimePosts);
